import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { Button } from "@mui/material";
import { useState } from "react";
import dayjs from "configs/dayjs.config";

import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";
import { FormControlWrapper } from "components/Wrappers/FormComponentsWrappers/FormControlWrapper";
import { SearchUsers } from "components/SearchSelect/SearchUsers";
import { useGlobalContext } from "context/GlobalContext";
import { addTaskForDocsApi } from "API/apis/docTasks/dockTask";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { useProjectContext } from "../context";
import { projectOperationsList } from "../constants/project.constants";
import { ProjectTopBanner } from "../components/ProjectTopBanner";
import { taskDocId } from "constants/documentCode";
import { DatePickerWrapper } from "components/DateTimePicker/DatePicker";
import { dateTimeFormat } from "constants/componentsConstants";

const initialUserDetail = {
  name: "",
  dept: "",
  subDept: "",
  userId: "",
};

const initialState = {
  docType: taskDocId.project,
  docId: 0,
  taskDetails: "",
  deadline: new Date(),
  taskTo: { name: "", dept: "", subDept: "", userId: "" },
  companyId: 0,
  docDetails: "",
};

export const ProjectTask = () => {
  const [formData, setFormData] = useState(initialState);
  const { setIsLoading, setSuccess, setError } = useGlobalContext();
  const { previewProject, setCurrentOperationPage } = useProjectContext();
  const [selectedTaskByUser, setSelectedTaskByUser] =
    useState(initialUserDetail);
  const [selectedTaskToUser, setSelectedTaskToUser] =
    useState(initialUserDetail);
  const handleDeliveryDateChange = (newValue) => {
    if (newValue) {
      setFormData({
        ...formData,
        deadline: dayjs(newValue).format(dateTimeFormat.date),
      });
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      docType: taskDocId.project,
      docId: previewProject.id,
      docDetails: previewProject.clientName,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddTaskUserSubmit = async (e) => {
    e.preventDefault();
    try {
      if (dayjs().subtract(1, "day") > formData.deadline) {
        throw new Error("Older dates are not allowed");
      }
      setIsLoading(true);
      const { data, status } = await addTaskForDocsApi({
        ...formData,
        taskTo: selectedTaskToUser?.userId || "",
        taskBy: selectedTaskByUser?.userId || "",
      });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setFormData(initialState);
      setSuccess(data?.message);
      setIsLoading(false);
      setCurrentOperationPage(projectOperationsList.listProject);
    } catch (error) {
      setIsLoading(false);
      setError(error.message);
    }
  };

  return (
    <>
      <PageTitle pageName={pageName.project.task} />
      <ProjectTopBanner
        buttonType="back"
        enquiryOperationsParam={projectOperationsList.listProject}
      />
      <form onSubmit={handleAddTaskUserSubmit}>
        <TextFieldWrapper
          multiline
          id="taskDetails"
          name="taskDetails"
          label="Task Detail"
          variant="outlined"
          value={formData.taskDetails}
          fullWidth
          required
          onChange={handleChange}
        />
        <TextFieldWrapper
          multiline
          id="taskDescription"
          name="taskDescription"
          label="Task Description"
          variant="outlined"
          value={formData.taskDescription}
          rows={5}
          fullWidth
          required
          onChange={handleChange}
        />
        <FormControlWrapper fullWidth>
          <SearchUsers
            label="Assign By"
            handleUserSelection={setSelectedTaskByUser}
            selectedUser={selectedTaskByUser}
          />
        </FormControlWrapper>
        <FormControlWrapper fullWidth>
          <SearchUsers
            label="Assign To"
            handleUserSelection={setSelectedTaskToUser}
            selectedUser={selectedTaskToUser}
          />
        </FormControlWrapper>
        <TextFieldWrapper
          id="alertBeforeDays"
          name="alertBeforeDays"
          label="Alert Before Days"
          variant="outlined"
          value={formData.alertBeforeDays}
          fullWidth
          inputProps={{ min: 1 }}
          required
          onChange={handleChange}
        />
        <FormControlWrapper fullWidth>
          <DatePickerWrapper
            label="Delivery Date"
            value={dayjs(formData.deadline)}
            onChange={(newValue) => handleDeliveryDateChange(dayjs(newValue))}
          />
        </FormControlWrapper>
        <Button variant="contained" type="submit" fullWidth>
          Submit
        </Button>
      </form>
    </>
  );
};
